class LoadButton {
    constructor(button) {
        this.nextDom = document;
        this.loadBtnElement = button;
        this.container = button
            .closest(".gh-archive-feed-wrapper")
            .querySelector(".gh-posts-feed");

        if (button) {
            this.toLoadMore();
            this.loadNextPage();
        }
    }

    async loadNextPage() {
        const next = this.nextDom.querySelector('link[rel="next"]');

        if (next) {
            let url = next.href;
            
            // Add loading state
            this.loadBtnElement.classList.add('gh-load-more-button--loading');
            this.loadBtnElement.disabled = true;
            this.loadBtnElement.setAttribute('aria-busy', 'true');

            try {
                const response = await fetch(url);
                if (!response.ok) {
                    this.loadBtnElement.style.display = "none";
                    return;
                }
                this.nextDom = document
                    .createRange()
                    .createContextualFragment(await response.text());
            } catch {
                this.loadBtnElement.style.display = "none";
            } finally {
                // Remove loading state
                this.loadBtnElement.classList.remove('gh-load-more-button--loading');
                this.loadBtnElement.disabled = false;
                this.loadBtnElement.setAttribute('aria-busy', 'false');
            }
        } else {
            this.loadBtnElement.style.display = "none";
        }
    }

    toLoadMore() {
        const handleLoad = async () => {
            if (this._loading) return;
            // Don't append from the live document (initial state before first fetch completes)
            if (this.nextDom === document) return;
            this._loading = true;

            // Append posts from previously fetched page
            for (const post of this.nextDom.querySelectorAll(
                ".gh-posts-feed .gh-posts-feed-post"
            )) {
                this.container.appendChild(post);
            }

            // Pre-fetch the next page for the following click
            await this.loadNextPage();
            this._loading = false;
        };

        this.loadBtnElement.addEventListener("click", handleLoad);
    }
}

export const loadMore = () => {
    const btnsLoad = document.querySelectorAll(".gh-load-more-button");

    if (!btnsLoad.length) {
        return;
    }

    btnsLoad.forEach((btn) => new LoadButton(btn));
};
